import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { VerticalTabComponent } from './vertical-tab.component';
import { Tab } from '../../../models/tabs.models';

@Component({
  selector: 'ui-vertical-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VerticalTabComponent],
  template: `
    @if (this.tabsSignal().length) {
      @for (tab of tabsSignal(); track $index) {
        <ui-vertical-tab [tab]="tab" (onTabClick)="selectTab($index)" />
      }
    }
  `,
})
export class VerticalTabsComponent {
  tabs = input<Tab[]>([]);
  tabsSignal = signal<Tab[]>([]);
  onTabClick = output<number>();

  ngOnInit() {
    // Initialize tabsSignal after tabs input is available
    this.tabsSignal.set([...this.tabs()]);
  }

  constructor() {
    effect(() => {
      this.tabsSignal.set([...this.tabs()]);
    });
  }

  selectTab(selectedTabIndex: number) {
    const tabs = [...this.tabsSignal()];
    const newTabs = tabs.map((tab, index) => ({
      ...tab,
      active: selectedTabIndex === index,
    }));
    this.tabsSignal.set(newTabs);
    this.onTabClick.emit(selectedTabIndex);
  }
}
